import { ReduxStateType } from "redux-store/types";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export enum InterviewType {
  FEEDBACK = "feedback",
  EVALUATE = "evaluate",
}
interface InitialState {
  status: ReduxStateType;
}

const initialState: InitialState = {
  status: ReduxStateType.INIT,
};

const getDetailInterviewSlice = createSlice({
  name: "recruitmentCampaignDetailInterview",
  initialState,
  reducers: {
    getDetailInterviewStart: (
      state,
      action: PayloadAction<{
        screenCode: string;
        scheduleId: string;
        userCode?: string;
      }>
    ) => {
      state.status = ReduxStateType.LOADING;
    },
    getDetailInterviewSuccess: (state, action) => {
      state.status = ReduxStateType.SUCCESS;
    },
    getDetailInterviewFailed: (state) => {
      state.status = ReduxStateType.ERROR;
    },
    resetListCandidate: () => ({ ...initialState }),
  },
});

export const {
  getDetailInterviewStart,
  getDetailInterviewSuccess,
  getDetailInterviewFailed,
  resetListCandidate,
} = getDetailInterviewSlice.actions;

export default getDetailInterviewSlice.reducer;
